import {
  Box,
  Button,
  VStack,
  StackDivider,
  Text,
  Divider
} from "@chakra-ui/react"
import { FC } from "react"
import { OnboardingStyleVars } from "./Onboarding"

type StepSelectorProps = {
  title?: string
  options: { id: string; name: string; enabled?: boolean }[]
  onSelect: (value: any) => void
  onBack: () => void
  canGoBack: boolean
  buttonColor: string
  buttonHoverColor: string
  styleVars: OnboardingStyleVars
}

const StepSelector: FC<StepSelectorProps> = ({
  title,
  options,
  onSelect,
  onBack,
  canGoBack,
  buttonColor,
  buttonHoverColor,
  styleVars
}) => (
  <VStack
    spacing={4}
    // divider={<StackDivider />}
    align="stretch"
    width={["300px", "500px", "500px"]}
    padding={4}
    borderRadius="md"
    boxShadow="lg"
  >
    {title && (
      <Text
        textAlign={"center"}
        color={styleVars.textColor}
        fontSize="3xl"
        fontWeight="bold"
        mb={2}
      >
        {title}
      </Text>
    )}
    <VStack overflow={"auto"} maxHeight="300px" align="stretch">
      {options.map(option => (
        <Button
          minHeight={"50px"}
          fontSize="lg"
          disabled={option?.enabled === false}
          key={option.id}
          onClick={() => onSelect(option)}
          bg={buttonColor}
          _hover={{ bg: buttonHoverColor }}
        >
          {option.name}
        </Button>
      ))}
    </VStack>
    <Divider></Divider>
    <Button
      minHeight={"50px"}
      fontSize="lg"
      bg={buttonColor}
      _hover={{ bg: buttonHoverColor }}
      onClick={onBack}
      disabled={!canGoBack}
    >
      Back
    </Button>
  </VStack>
)

export default StepSelector
